import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AfficheReservationMensuel = async (idRestaurant) => {
    return await axios.get(`${BASE_URL}/api/restaurant/afficheResaMensuel/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}


export { AfficheReservationMensuel }